import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import type { LabelAndValue } from '@/types/label-and-value'
import { mockPaginatedQuery } from '@/utils/mocks'
import { idAndNameSchema, requiredString } from '@/utils/zod'

import { createSchoolYearsListMock } from '../../mocks/section-school-years'
import { encodeSchoolYearsValue } from '../../utils/school-years-value'

const responseSchema = z.array(
  z.object({
    name: requiredString(),
    start_year: requiredString(), // id start year
    end_year: requiredString(), // id end year
    education_level: idAndNameSchema
  })
)

const parseResponse = (
  results: z.infer<typeof responseSchema>
): LabelAndValue[] =>
  results.map(item => ({
    label: item.name,
    value: encodeSchoolYearsValue({
      startYear: item.start_year,
      endYear: item.end_year
    }),
    meta: item.education_level
  }))

export const useSectionSchoolYears = (educationLevelId?: string) =>
  useQuery({
    queryKey: ['panelSelectSectionsSchoolYearsList', educationLevelId],
    queryFn: async () => {
      // TODO: Remove mock when API is ready - https://panowie.atlassian.net/browse/RG-367
      const response = await mockPaginatedQuery(
        createSchoolYearsListMock({
          page: 1,
          page_size: 'max',
          education_level_id: educationLevelId ? [educationLevelId] : undefined,
          fetchKeys: {
            name: true,
            start_year: true,
            end_year: true,
            education_level: true
          }
        })
      )

      return parseResponse(responseSchema.parse(response.results))
    }
  })
